'use client';

import { useEffect } from 'react';
import { createAccessLog } from '~/lib/access-logs';

export function AccessLogTracker() {
  useEffect(() => {
    const trackAccess = async () => {
      try {
        await createAccessLog();
      } catch (error) {
        console.error('Error tracking access:', error);
      }
    };

    trackAccess();
  }, []);

  // このコンポーネントは何もレンダリングしない
  return null;
}
